"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _deprecate = _interopRequireDefault(require("../../utils/deprecate"));

var _excluded = ["className", "svgRef"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Icon = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(Icon, _React$PureComponent);

  var _super = _createSuper(Icon);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          svgRef = _this$props.svgRef,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, _classnames.default)('ui-icon', className),
        ref: svgRef
      }, otherProps), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.453,0 C4.23225226,-3.196786e-16 6.39357201e-16,4.23225226 0,9.453 C-6.39357201e-16,14.6737477 4.23225226,18.906 9.453,18.906 C14.6737477,18.906 18.906,14.6737477 18.906,9.453 C18.8999384,4.23476513 14.6712349,0.00606163384 9.453,0 Z M9.453,17.906 C4.78453701,17.906 1,14.121463 1,9.453 C1,4.78453701 4.78453701,1 9.453,1 C14.121463,1 17.906,4.78453701 17.906,9.453 C17.9004896,14.1191786 14.1191786,17.9004896 9.453,17.906 Z M9.27,14.555 C9.73391919,14.555 10.11,14.1789192 10.11,13.715 C10.11,13.2510808 9.73391919,12.875 9.27,12.875 C8.80608081,12.875 8.43,13.2510808 8.43,13.715 C8.43,14.1789192 8.80608081,14.555 9.27,14.555 Z M9.735,4.328 C8.67658577,4.33183151 7.68251049,4.83665855 7.055,5.689 L7.883,6.249 C8.32369869,5.67050862 9.00876846,5.33037684 9.736,5.329 C10.797,5.329 11.457,5.869 11.503,6.772 C11.5092935,7.52821971 11.1117154,8.23036625 10.46,8.614 C9.55626334,9.13464452 8.95131501,10.051334 8.828,11.087 C8.828,11.276 8.815,11.856 8.815,11.856 L9.815,11.877 C9.815,11.877 9.828,11.277 9.828,11.086 C9.828,10.601 10.266,10.007 11.059,9.414 C11.9839354,8.83634853 12.532584,7.81101149 12.5,6.721 C12.4651124,6.03152287 12.1502091,5.38618679 11.6282009,4.93440893 C11.1061926,4.48263108 10.4223479,4.26358959 9.735,4.328 Z"
      }));
    }
  }]);
  return Icon;
}(_react.default.PureComponent);

Icon.displayName = 'HelpAltIcon';

var _default = (0, _deprecate.default)({
  message: 'Please use HelpStrokeIcon. ',
  name: Icon.displayName
})(Icon);

exports.default = _default;
//# sourceMappingURL=HelpAlt.js.map